<h2 mat-dialog-title class="dialog-header">
  <div class="title-left">
    <img width="22px"
         height="22px"
         src="assets/images/svg/nav-bar/Aggregate.svg"
         alt="aggregate icon"
         class="me-2"/>
    <span>Aggregated Report</span>
  </div>
  <div class="header-controls">
    <mat-form-field appearance="outline" class="compact-datepicker">
      <mat-label>Month and Year</mat-label>
      <input matInput [matDatepicker]="picker" [formControl]="startDate">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker startView="multi-year" panelClass="month-picker"></mat-datepicker>
    </mat-form-field>

    <mat-checkbox (change)="isToolBarActive$.next($event.checked)" class="toolbar-checkbox">
      Show Toolbar for Export & Print
    </mat-checkbox>
  </div>
</h2>

<mat-dialog-content class="mat-typography dialog-body-content">
  <p class="helper-text">
    Select a month to view the aggregated utility summary. Use the toolbar option to export or print the report.
  </p>

  <div class="report-preview-card">
    <div class="frame-container" *ngIf="url; else noData">
      <iframe
        [src]="url | safe"
        allowfullscreen></iframe>
    </div>
    <ng-template #noData>
      <div class="loading-spinner">
        <mat-spinner></mat-spinner>
      </div>
    </ng-template>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-button (click)="onNoClick()" class="close-btn">
    Close
  </button>
</mat-dialog-actions>
